import StyleLayer from '../style_layer';
import properties from './raster_style_layer_properties';
class RasterStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties);
    }
}
export default RasterStyleLayer;
//# sourceMappingURL=raster_style_layer.js.map